import { Card, CardContent, Typography, CircularProgress } from '@mui/material'
import PropTypes from 'prop-types'
import { faFrown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useState } from 'react'

const styles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    height: '300px',
  },
  title: {
    color: theme.palette.primary.dark,
    zIndex: '1',
    position: 'relative',
  },
  icon: {
    position: 'absolute',
    fontSize: '19rem',
    color: theme.palette.background.default,
    opacity: '0.4',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%);',
    zIndex: '0',
  },
  loading: {
    fontSize: '50px',
  },
}))

const NoContent = () => {
  const classes = styles()

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)

    const timer = setTimeout(() => {
      setLoading(false)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <Card className={classes.content} elevation={0}>
        <CardContent>
          <>
            {loading && (
              <CircularProgress
                className={classes.loading}
                color="primary"
                thickness={2}
                size="9rem"
              />
            )}
            {!loading && (
              <>
                <Typography className={classes.title} variant="h3">
                  Brak danych
                </Typography>
                <FontAwesomeIcon className={classes.icon} icon={faFrown} />
              </>
            )}
          </>
        </CardContent>
      </Card>
    </>
  )
}

NoContent.propTypes = {
  loading: PropTypes.bool,
}

export default NoContent
